<template>
  <v-dialog
    v-model="dialog"
    width="600"
    persistent
    scrollable
  >
    <v-card style="position: relative;">
      <v-overlay
        absolute
        :value="newsLoading"
        class="text-center"
      >
        <v-progress-circular
          indeterminate
          :size="50"
          color="primary"
        />
        <p class="text-overline white--text mt-4">
          Loading...
        </p>
      </v-overlay>
      <v-card-title>What's New  <v-spacer /><span class="text-caption">Patch {{ appTag }}</span></v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <!-- eslint-disable vue/no-v-html -->
            <div v-html="newsContent" />
            <!-- eslint-enable -->
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          color="secondary"
          text
          @click="_ => onDontShowAgain()"
        >
          Dont' show again
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { marked } from 'marked'

import { USER_NAMESPACE } from '@/store/user'

export default {
  name: 'NewsDialog',

  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      appTag: process.env.VUE_APP_GIT_TAG,
    }
  },

  computed: {
    dialog: {
      get () {
        return this.value
      },

      set (value) {
        this.$emit('input', value)
      },
    },

    newsContent () {
      return marked.parse(this.news || '')
    },

    ...mapGetters(USER_NAMESPACE, [
      'news',
      'newsLoading',
    ]),
  },

  watch: {
    dialog (value) {
      if (value) {
        this.fetchNews()
      }
    },
  },

  methods: {
    onDontShowAgain () {
      this.markNewsAsSeen().then(_ => {
        this.dialog = false
      })
    },

    ...mapActions(USER_NAMESPACE, [
      'fetchNews',
      'markNewsAsSeen',
    ]),
  },
}
</script>
